/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RunCustomFunctionDefinitionRequestDto } from '../models/run-custom-function-definition-request-dto';
import { RunWorkflowEventRequestDto } from '../models/run-workflow-event-request-dto';
import { RunWorkflowServiceRequestDto } from '../models/run-workflow-service-request-dto';
import { RunWorkflowStepFunctionRequestDto } from '../models/run-workflow-step-function-request-dto';
import { TriggeredWorkflowProcess } from '../models/triggered-workflow-process';
import { TriggeredWorkflowStepFunctionDetails } from '../models/triggered-workflow-step-function-details';

@Injectable({
  providedIn: 'root',
})
export class WorkflowManagementControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation workflowManagementControllerRunCustomFunctionDefinition
   */
  static readonly WorkflowManagementControllerRunCustomFunctionDefinitionPath = '/workflow-management/custom-function-definition/run';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runCustomFunctionDefinition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runCustomFunctionDefinition$Response(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunCustomFunctionDefinitionRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunCustomFunctionDefinitionPath, 'post');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runCustomFunctionDefinition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runCustomFunctionDefinition(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunCustomFunctionDefinitionRequestDto
  }): Observable<any> {

    return this.runCustomFunctionDefinition$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunCustomFunctionDefinitionWithJwt
   */
  static readonly WorkflowManagementControllerRunCustomFunctionDefinitionWithJwtPath = '/workflow-management/custom-function-definition/run-with-jwt';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runCustomFunctionDefinitionWithJWT()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runCustomFunctionDefinitionWithJWT$Response(params?: {
    body?: RunCustomFunctionDefinitionRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunCustomFunctionDefinitionWithJwtPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runCustomFunctionDefinitionWithJWT$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runCustomFunctionDefinitionWithJWT(params?: {
    body?: RunCustomFunctionDefinitionRequestDto
  }): Observable<any> {

    return this.runCustomFunctionDefinitionWithJWT$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerGetWorkflowLogsWithExecutions
   */
  static readonly WorkflowManagementControllerGetWorkflowLogsWithExecutionsPath = '/workflow-management/logs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkflowLogsWithExecutions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkflowLogsWithExecutions$Response(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    correlationId?: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerGetWorkflowLogsWithExecutionsPath, 'get');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.query('correlationId', params.correlationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getWorkflowLogsWithExecutions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkflowLogsWithExecutions(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    correlationId?: string;
  }): Observable<any> {

    return this.getWorkflowLogsWithExecutions$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunWorkflowEvent
   */
  static readonly WorkflowManagementControllerRunWorkflowEventPath = '/workflow-management/workflow-events/run';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runWorkflowEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowEvent$Response(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunWorkflowEventRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunWorkflowEventPath, 'post');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runWorkflowEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowEvent(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunWorkflowEventRequestDto
  }): Observable<any> {

    return this.runWorkflowEvent$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunWorkflowEventWithJwt
   */
  static readonly WorkflowManagementControllerRunWorkflowEventWithJwtPath = '/workflow-management/workflow-events/run-with-jwt';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runWorkflowEventWithJWT()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowEventWithJWT$Response(params?: {
    body?: RunWorkflowEventRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunWorkflowEventWithJwtPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runWorkflowEventWithJWT$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowEventWithJWT(params?: {
    body?: RunWorkflowEventRequestDto
  }): Observable<any> {

    return this.runWorkflowEventWithJWT$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerGetStepFunctionResponse
   */
  static readonly WorkflowManagementControllerGetStepFunctionResponsePath = '/workflow-management/workflow-step-function/{workflowStepFunctionId}/response/{correlationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStepFunctionResponse()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStepFunctionResponse$Response(params: {
    workflowStepFunctionId: string;
    correlationId: string;
    publicAPIKey: string;
    secretAPIKey: string;
    includeResponse?: boolean;
  }): Observable<StrictHttpResponse<TriggeredWorkflowStepFunctionDetails>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerGetStepFunctionResponsePath, 'get');
    if (params) {
      rb.path('workflowStepFunctionId', params.workflowStepFunctionId, {});
      rb.path('correlationId', params.correlationId, {});
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.query('includeResponse', params.includeResponse, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TriggeredWorkflowStepFunctionDetails>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getStepFunctionResponse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStepFunctionResponse(params: {
    workflowStepFunctionId: string;
    correlationId: string;
    publicAPIKey: string;
    secretAPIKey: string;
    includeResponse?: boolean;
  }): Observable<TriggeredWorkflowStepFunctionDetails> {

    return this.getStepFunctionResponse$Response(params).pipe(
      map((r: StrictHttpResponse<TriggeredWorkflowStepFunctionDetails>) => r.body as TriggeredWorkflowStepFunctionDetails)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunWorkflowStepFunctionServiceSync
   */
  static readonly WorkflowManagementControllerRunWorkflowStepFunctionServiceSyncPath = '/workflow-management/workflow-step-function-services/run-sync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runWorkflowStepFunctionServiceSync()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionServiceSync$Response(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunWorkflowServiceRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunWorkflowStepFunctionServiceSyncPath, 'post');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runWorkflowStepFunctionServiceSync$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionServiceSync(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunWorkflowServiceRequestDto
  }): Observable<any> {

    return this.runWorkflowStepFunctionServiceSync$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunWorkflowStepFunctionServiceSyncWithJwt
   */
  static readonly WorkflowManagementControllerRunWorkflowStepFunctionServiceSyncWithJwtPath = '/workflow-management/workflow-step-function-services/run-sync-with-jwt';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runWorkflowStepFunctionServiceSyncWithJWT()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionServiceSyncWithJWT$Response(params?: {
    body?: RunWorkflowServiceRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunWorkflowStepFunctionServiceSyncWithJwtPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runWorkflowStepFunctionServiceSyncWithJWT$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionServiceSyncWithJWT(params?: {
    body?: RunWorkflowServiceRequestDto
  }): Observable<any> {

    return this.runWorkflowStepFunctionServiceSyncWithJWT$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerGetStepFunctionsResponse
   */
  static readonly WorkflowManagementControllerGetStepFunctionsResponsePath = '/workflow-management/workflow-step-functions/response/{correlationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStepFunctionsResponse()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStepFunctionsResponse$Response(params: {
    correlationId: string;
    publicAPIKey?: string;
    secretAPIKey?: string;
    includeResponse?: boolean;
  }): Observable<StrictHttpResponse<TriggeredWorkflowProcess>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerGetStepFunctionsResponsePath, 'get');
    if (params) {
      rb.path('correlationId', params.correlationId, {});
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.query('includeResponse', params.includeResponse, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TriggeredWorkflowProcess>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getStepFunctionsResponse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStepFunctionsResponse(params: {
    correlationId: string;
    publicAPIKey?: string;
    secretAPIKey?: string;
    includeResponse?: boolean;
  }): Observable<TriggeredWorkflowProcess> {

    return this.getStepFunctionsResponse$Response(params).pipe(
      map((r: StrictHttpResponse<TriggeredWorkflowProcess>) => r.body as TriggeredWorkflowProcess)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunWorkflowStepFunctionAsync
   */
  static readonly WorkflowManagementControllerRunWorkflowStepFunctionAsyncPath = '/workflow-management/workflow-step-functions/run-async';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runWorkflowStepFunctionAsync()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionAsync$Response(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunWorkflowStepFunctionRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunWorkflowStepFunctionAsyncPath, 'post');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runWorkflowStepFunctionAsync$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionAsync(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunWorkflowStepFunctionRequestDto
  }): Observable<any> {

    return this.runWorkflowStepFunctionAsync$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunWorkflowStepFunctionAsyncWithJwt
   */
  static readonly WorkflowManagementControllerRunWorkflowStepFunctionAsyncWithJwtPath = '/workflow-management/workflow-step-functions/run-async-with-jwt';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runWorkflowStepFunctionAsyncWithJWT()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionAsyncWithJWT$Response(params?: {
    body?: RunWorkflowStepFunctionRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunWorkflowStepFunctionAsyncWithJwtPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runWorkflowStepFunctionAsyncWithJWT$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionAsyncWithJWT(params?: {
    body?: RunWorkflowStepFunctionRequestDto
  }): Observable<any> {

    return this.runWorkflowStepFunctionAsyncWithJWT$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunWorkflowStepFunctionSync
   */
  static readonly WorkflowManagementControllerRunWorkflowStepFunctionSyncPath = '/workflow-management/workflow-step-functions/run-sync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runWorkflowStepFunctionSync()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionSync$Response(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunWorkflowStepFunctionRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunWorkflowStepFunctionSyncPath, 'post');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runWorkflowStepFunctionSync$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionSync(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    body?: RunWorkflowStepFunctionRequestDto
  }): Observable<any> {

    return this.runWorkflowStepFunctionSync$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunWorkflowStepFunctionSyncWithJwt
   */
  static readonly WorkflowManagementControllerRunWorkflowStepFunctionSyncWithJwtPath = '/workflow-management/workflow-step-functions/run-sync-with-jwt';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runWorkflowStepFunctionSyncWithJWT()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionSyncWithJWT$Response(params?: {
    body?: RunWorkflowStepFunctionRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunWorkflowStepFunctionSyncWithJwtPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runWorkflowStepFunctionSyncWithJWT$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runWorkflowStepFunctionSyncWithJWT(params?: {
    body?: RunWorkflowStepFunctionRequestDto
  }): Observable<any> {

    return this.runWorkflowStepFunctionSyncWithJWT$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

}
